export function base64Decode(base64Str: string): string {
	if (typeof base64Str !== 'string') {
		throw new TypeError('Input must be a string');
	}
	if (!base64Str) {
		return '';
	}

	const binary = atob(base64Str);
	const bytes = new Uint8Array(binary.length);
	for (let i = 0; i < binary.length; i++) {
		bytes[i] = binary.charCodeAt(i);
	}

	return new TextDecoder().decode(bytes);
}

export function jwtDecode<T = unknown & { iat: number; exp: number }>(
	token: string,
): T {
	if (typeof token !== 'string') {
		throw new Error('Invalid token specified: must be a string');
	}

	const payloadStrEncoded = token.split('.')[1];
	const payloadStr = base64Decode(payloadStrEncoded);

	try {
		return JSON.parse(payloadStr);
	} catch (e) {
		throw new Error(
			`Invalid token specified: invalid json (${(e as Error).message})`,
		);
	}
}
